export default __webpack_public_path__ + "static/media/MTbasico_LateralDer.bb478cf8.webp";